module.exports = __webpack_public_path__ + "media/images/gallery/constellations/hercules/her_lines-0adc79c91907e17415a92f7fa10a1eb1.gif";